export default function PolicyModal({ open, onClose, title, content }) {
  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="policy-modal-title"
      className="fixed inset-0 z-[60] flex items-start md:items-center justify-center bg-black/50 overflow-hidden box-border"
      style={{
        paddingTop: "max(1rem, env(safe-area-inset-top))",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        paddingBottom: "1rem",
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-lg flex flex-col min-h-0 overflow-hidden"
        style={{ maxHeight: "calc(100vh - max(1rem, env(safe-area-inset-top)) - 2rem)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="shrink-0 flex items-center gap-3 px-4 py-3 border-b border-gray-200 bg-white rounded-t-2xl flex-none">
          <h2 id="policy-modal-title" className="text-base font-semibold text-gray-900 min-w-0 flex-1 pr-2">
            {title}
          </h2>
          <button
            type="button"
            aria-label="Close"
            onClick={onClose}
            className="shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-gray-600 hover:bg-gray-100 border border-gray-200"
          >
            ×
          </button>
        </header>
        <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden overscroll-contain">
          <div className="px-4 pt-4 pb-12 text-left text-sm text-gray-700 leading-relaxed whitespace-pre-line">
            {content}
          </div>
        </div>
      </div>
    </div>
  );
}
